import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

type PublishResultsDialogProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: (result: "create" | "create-publish") => Promise<void>;
};

const PublishResultsDialog: React.FC<PublishResultsDialogProps> = ({
                                                                       open,
                                                                       onClose,
                                                                       onConfirm
                                                                   }) => {

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Ukončit závod a publikovat výsledky</DialogTitle>
            <DialogContent>
                <Typography>Opravdu chcete ukončit pořádání závodu?</Typography>
                <Typography>Před ukončením je nutné zaznamenat všechny průjezdy lodí.</Typography>
                <Typography fontWeight="bold">Tato akce je navratná.</Typography>

                <Typography sx={{mt: 2}}>Výsledky budou publikovány v sekci výsledků veřejně.</Typography>
                <Typography>Pokud se rozhodnete výsledky nepublikovat, můžete tak učinit později v sekci pořádání
                    závodu.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Zrušit
                </Button>
                <Button
                    onClick={() => {
                        onConfirm("create-publish")
                        onClose();
                    }}
                    variant="outlined"
                    color="error"
                >
                    Ukončit a publikovat
                </Button>
                <Button
                    onClick={() => {
                        onConfirm("create")
                        onClose();
                    }}
                    variant="contained"
                    color="error"
                >
                    Ukončit bez publikace
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PublishResultsDialog;